import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function CoinsCross({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M3.00023 8C3.00023 9.1 5.23023 10 8.00023 10M3.00023 8V16C3.00023 17.1 5.23923 18 8.00023 18M3.00023 8C3.00023 7.46957 3.52702 6.96086 4.4647 6.58579C5.40238 6.21071 6.67415 6 8.00023 6C9.32632 6 10.5981 6.21071 11.5358 6.58579C12.4735 6.96086 13.0002 7.46957 13.0002 8M3.00023 8C3.00023 8.53043 3.52702 9.03914 4.4647 9.41421C5.40238 9.78929 6.67415 10 8.00023 10M8.00023 10C9.32632 10 10.5981 9.78929 11.5358 9.41421C12.4735 9.03914 13.0002 8.53043 13.0002 8M16.0002 21C13.2302 21 11.0002 20.1 11.0002 19V15C11.0002 16.1 13.2302 17 16.0002 17C18.7602 17 21.0002 16.1 21.0002 15L20.9992 19C20.9992 20.1 18.7592 21 15.9992 21M13.0002 8V10.5M17.5002 6.5L20.5002 3.5M20.5002 6.5L17.5002 3.5M3.00023 12C3.00023 13.1 5.23023 13.99 7.99923 13.99M7.99023 14C5.22023 14 2.99023 13.1 2.99023 12M20.9972 15C20.9972 13.89 18.7572 13 15.9972 13C13.2372 13 10.9972 13.89 10.9972 15C10.9972 16.1 13.2272 17 15.9972 17C18.7572 17 20.9972 16.1 20.9972 15Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default CoinsCross;